import { PluginDefinition } from 'yam-types'
import accessOperator from './handlers/access'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { AccessApproachConfig } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'access[*]': accessOperator
  }
} as PluginDefinition<AccessApproachConfig>